<template>
  <v-container>
    <v-card class="pa-8 mx-auto" max-width="800">
      <!-- タイトル -->
      <v-row class="mb-8">
        <v-col class="text-center">
          <h2 class="text-h5 font-weight-bold">
            JWNET-EDI連携サービス利用申し込み画面
          </h2>
        </v-col>
      </v-row>

      <!-- 本文 -->
      <v-row class="mb-8">
        <v-col>
          <p class="mb-4">
            {{ name }}　{{ staff_1 }}様
          </p>
          <p class="mb-4">
            {{ tenant_name }}からJWNET-EDI連携サービスのサービス申し込み画面のご案内です。
          </p>
          <p>
            以下の手順に従い、JWNET-EDI連携サービス申し込みをお願いいたします。
          </p>
        </v-col>
      </v-row>

      <!-- 申請済みメッセージ -->
      <v-row v-if="requested" class="mb-8">
        <v-col class="text-center">
          <v-alert
            type="info"
            outlined
            prominent
          >
            申請済みです
          </v-alert>
        </v-col>
      </v-row>

      <!-- ボタンセクション（未申請時のみ表示） -->
      <template v-else>
        <!-- JWNET未加入セクション -->
      <v-row class="mb-8" v-if="request_type==='request_new' || request_type===null">
        <v-col>
          <p class="text-center mb-4">
            JWNETに未加入の方はこちら
          </p>
          <v-btn
            block
            large
            outlined
            color="primary"
            class="text-none"
            @click="navigateToNewRegistration"
          >
            新規申込を行う
          </v-btn>
        </v-col>
      </v-row>

      <!-- JWNET加入済みセクション -->
        <v-row v-if="request_type==='request_joined' || request_type===null">
          <v-col>
            <p class="text-center mb-4">
              既にA料金/B料金/C料金/不明でJWNETに加入済みの方はこちら
            </p>
            <v-btn
              block
              large
              outlined
              color="primary"
              class="text-none"
              @click="navigateToExistingRegistration"
            >
              JWNET加入情報を利用して申込を行う
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'EdiRequestRegistrationIndex',
  data() {
    return {
      token: null,
      name: null,
      staff_1: null,
      tenant_name: null,
      requested: false,
      request_type: null,
    }
  },
  created() {
    this.token = this.$route.params.token
    this.loader()
  },
  methods: {
    ...mapActions('EdiRequestRegistration', {
      fetchEmission: 'index',
    }),
    navigateToNewRegistration() {
      this.$router.push(`/edi_request/${this.token}/unsubscribed/new`)
    },
    navigateToExistingRegistration() {
      this.$router.push(`/edi_request/${this.token}/subscribed/new`)
    },
    loader () {
      this.fetchEmission({ edi_request_token: this.token }).then((content) => {
        this.name = content.name
        this.staff_1 = content.staff_1
        this.tenant_name = content.tenant_name
        this.requested = content.requested
        this.request_type = content.request_type
      })
    },
  }
}
</script>

<style scoped>
.text-none {
  text-transform: none !important;
}
</style>
